// main.tsx
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App.tsx";
import "../i18n";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
  // Bruit de navigateurs tiers, pas notre code : le navigateur DuckDuckGo
  // (iOS) injecte ses propres scripts qui parlent a l'app native via
  // window.webkit.messageHandlers ; quand l'app ne repond pas, leur promesse
  // rejetee remonte en "unhandledrejection" sur notre page.
  ignoreErrors: [/WKWebView API client did not respond to this postMessage/],
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* Sans ce filet, une erreur de rendu React laisse une page blanche sur le
    site du studio (cf. widget-config.ts) au lieu d'un message minimal. */}
    <Sentry.ErrorBoundary
      fallback={
        <p style={{ padding: 16, fontFamily: "sans-serif" }}>
          Une erreur est survenue. Merci de rafraîchir la page.
        </p>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
